<template>
    <v-dialog v-model="showDialog_CheckinCheckout" width="850" persistent>
        <v-card>
            <v-card-title class="blue-grey pa-5" style="color: white; font-size: 15px;  font-weight: 500;">
                <i style="font-size:20px;" class="b-fa b-fa-user-check"></i>&nbsp;&nbsp;Select/Modify CheckIn/CheckOut Times
            </v-card-title>

            <!-- Selected CiCo List ---------------------------------------- -->
            <div style="font-size: 15px; font-weight: 700; color: #606263; padding-left: 28px; margin-top:15px; margin-bottom: 0px;"><i style="font-size:15px; color: red; padding-right: 10px;" class="b-fa b-fa-user"></i><strong>Choose your Employees/CiCo:</strong></div>
            <selected-cico-list v-model="employees" v-if="showDialog_CheckinCheckout" />

            <v-divider style="margin-top: 20px;"></v-divider>

           <!-- Selecting Standby ------------------------------------------ -->
            <div style="font-size: 15px; font-weight: 700; color: #606263; padding-left: 28px; margin-top:15px;"><i style="font-size:15px; color: red; padding-right: 10px;" class="b-fa b-fa-user"></i><strong>Build your Check/Checkout:</strong></div>
            <v-card-text class="pa-5">
                <datetime v-model="startDate" label="Checkin:" disabled="false" disabledTime="false" ref="startTimer" />
                <datetime v-model="endDate" label="Checkout:" disabled="false" disabledTime="false" ref="endTimer" />
            </v-card-text>


            <v-divider></v-divider>
            <!-- Card Actions ---------------------------------------------- -->
            <v-card-actions>
                <span style="font-size: 12px; font-weight: 700; color: #606263; padding-left: 25px;"><strong>Status:</strong></span>
                <div class="flex-grow-1"></div>
                <v-btn style="width:120px; font-size:12px;" depressed elevation="1" outlined color="#ab3b7a" @click="showDialog_CheckinCheckout = false">Cancel</v-btn>
                <v-btn style="width:120px; font-size:12px;" depressed elevation="1" color="primary" @click="onSave_CheckinCheckout">Save</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import Vue from 'vue';
    import Datetime from '../../DateTime.vue';
    import { mapActions, mapGetters } from 'vuex';
    import dayjs from "dayjs";
    import utc from 'dayjs/plugin/utc';

    import SelectedCicoList from './components/SelectedCiCoList.vue';


    export default {
        name : 'Dialog_CheckinCheckout',

        /* >>> *************************************************************** / /* Props */
        props : {
            value : [ Boolean, Object ], // showDialog_CheckinCheckout
        },
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Components */
        components : {

            Datetime,
            SelectedCicoList,

        }, // eo components{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Watch */
        watch: {

        }, // eo watch{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'get_flights_CrewDetails_SavedPayload', // getting 'idFlightGroup'
            ]),


            /*******************************************************************
            * showDialog_CheckinCheckout()
            *
            * Desc:
            * Note:
            *
            */
            showDialog_CheckinCheckout: {

                /***************************************************************
                * get()
                *
                * Note:.
                *
                */
                get() {

                    let me = this,
                        timestamp = null,
                        startDate = null,
                        endDate = null;


                    me.$toc('>>> views/crewplanning/crewplanning/components/calendar/crewdetails/dialoags/DialogCheckinCheckout.vue >>> showDialog_CheckinCheckout get');
                    timestamp = new Date(this.get_flights_CrewDetails_SavedPayload.date).setHours(0, 0, 0, 0);
                    startDate = new Date(timestamp);
                    timestamp = new Date(this.get_flights_CrewDetails_SavedPayload.date).setHours(23, 59, 0, 0);
                    endDate = new Date(timestamp);

                    Object.assign(me, {
                        startDate: startDate,
                        endDate: endDate,

                    });


                    // return always Boolean
                    return !!this.value;

                }, // eo showDialog_CheckinCheckout get()


                /***************************************************************
                * set()
                *
                * Desc:
                * Note: only runs on close.
                *
                */
                set(value) {

                    let me = this;;


                    me.$toc('>>> views/crewplanning/crewplanning/components/calendar/crewdetails/dialoags/DialogCheckinCheckout.vue >>> showDialog_CheckinCheckout set');
                    this.$emit('input', value);

                } // eo showDialog_CheckinCheckout set()

            } // eo function showDialog_CheckinCheckout()

        }, // eo computed{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Data */
        data() {

            return {
                // >>> ------------------------------
                startDate       : null,
                endDate         : null,
                // >>> ------------------------------
                employees : [],
            };

        }, // eo data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* methods */
        methods: {

            ...mapActions([
                'actn_call_crews_setDutyTimes'
            ]),


            /*******************************************************************
            * onSave_CheckinCheckout()
            *
            * Desc:
            * Note: Do one Call (multiple Ressources Array).
            */
            onSave_CheckinCheckout: function() {

                let me = this,
                    idResources  = [],
                    paramsDutyTimes = {
                        "fromDuty": null,
                        "idFlight": null,
                        "idResources": null,
                        "toDuty": null,
                    };


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/crewdetails/dialogs/Dialog_CheckinCheckout.vue >>> onSave_CheckinCheckout');
                // >>> ------------------------------------ Protector(s)
                if (this.employees.length === 0) {
                    Vue.prototype.$toasted.global.sdr_app_info({
                        message: 'Attention: Dear User, please select at least one Crewmember.'
                    });
                    return;
                }


                // >>> ------------------------------------ Call
                this.employees.forEach(member => {
                    idResources.push(member.id);
                });

                paramsDutyTimes = {
                    "fromDuty": dayjs(this.startDate).format("YYYY-MM-DD[T]HH:mm:ss[Z]"),
                    "idFlight":  this.get_flights_CrewDetails_SavedPayload.idFlightGroup,
                    "idResources": idResources,
                    "toDuty": dayjs(this.endDate).format("YYYY-MM-DD[T]HH:mm:ss[Z]"),
                };

                this.actn_call_crews_setDutyTimes(paramsDutyTimes);
                // <<< ------------------------------------


                // >>> ------------------------------------ Close/Reset/Reload
                setTimeout(() => {
                    Vue.prototype.$vp_um();
                    this.showDialog_CheckinCheckout = false;
                    // this.actn_call_getCrewDetailsFromFlight_Reduced({ idFlight: this.get_flights_CrewDetails_SavedPayload.idFlightGroup })
                }, 700);

            }, // eo function onSave_CheckinCheckout()

        } // eo methods{}
        /* <<< ****************************************************************/

    };
</script>

<style>
    .v-text-field.v-text-field--enclosed .v-text-field__details {
        margin-top: 4px !important;
    }
</style>
